import { render, staticRenderFns } from "./SelectBenefitsTable.vue?vue&type=template&id=7349c986&scoped=true"
import script from "./SelectBenefitsTable.vue?vue&type=script&lang=js"
export * from "./SelectBenefitsTable.vue?vue&type=script&lang=js"
import style0 from "./SelectBenefitsTable.vue?vue&type=style&index=0&id=7349c986&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7349c986",
  null
  
)

export default component.exports